export const defaultFieldOptions = [
   {
      id: "name",
      name: "Port Number"
   },
   {
      id: "port_type",
      name: "Port Type"
   },
   {
      id: "expiration",
      name: "Expiration"
   },
   {
      id: "unusable",
      name: "Broken/Unusable"
   }
];
export var resultModel = {
   'device_name': {
      'title': "Device",
      'display': true
   },
   'name': {
      'title': "Port Number",
      'display': true
   },
   'device_id': {
      'title': "Device ID",
      'display': false,
      'metadata': true
   },
   'port_type': {
      'title': "Port Type",
      'display': true
   },
   'mapped_device': {
      'title': "Mapped Device ID",
      'display': false
   },
   'mapped_device_name': {
      'title': "Mapped Device",
      'display': true
   },
   'expiration': {
      'title': "Expiration",
      'display': true
   },
   'unusable': {
      'title': "Broken/Unusable",
      'display': false
   }
};